export default "__VITE_ASSET__48JklaTfgnlRQjuF9BXSTA__"